import {
  isAutodeskLegacyProjectIntegration,
  isProcoreLegacyProjectIntegration,
  isProjectIntegration,
} from "@services/integrations-service/integrations-type-guards";
import { ProjectIntegrationsMap } from "@services/integrations-service/integrations-service-types";

/**
 * @returns Whether a project is connected to Autodesk based on the given project integrations map
 * @param projectIntegrationsMap Project integrations map
 */
export function isProjectConnectedToAutodesk(
  projectIntegrationsMap: ProjectIntegrationsMap | undefined
): boolean {
  if (!projectIntegrationsMap) {
    return false;
  }

  const isAutodeskLegacyConnected = isAutodeskLegacyProjectIntegration(
    projectIntegrationsMap.autodesk
  );
  const isAutodeskAccIssuesConnected = isProjectIntegration(
    projectIntegrationsMap["autodesk-acc.issues"]
  );
  const isAutodeskAccRfisConnected = isProjectIntegration(
    projectIntegrationsMap["autodesk-acc.rfis"]
  );
  const isAutodeskBim360IssuesConnected = isProjectIntegration(
    projectIntegrationsMap["autodesk-bim360.issues"]
  );
  const isAutodeskBim360RfisConnected = isProjectIntegration(
    projectIntegrationsMap["autodesk-bim360.rfis"]
  );

  return (
    isAutodeskLegacyConnected &&
    ((isAutodeskAccIssuesConnected && isAutodeskAccRfisConnected) ||
      (isAutodeskBim360IssuesConnected && isAutodeskBim360RfisConnected))
  );
}

/**
 * @returns Whether a project is connected to Procore based on the given project integrations map
 * @param projectIntegrationsMap Project integrations map
 */
export function isProjectConnectedToProcore(
  projectIntegrationsMap: ProjectIntegrationsMap | undefined
): boolean {
  if (!projectIntegrationsMap) {
    return false;
  }

  const isProcoreLegacyConnected = isProcoreLegacyProjectIntegration(
    projectIntegrationsMap.procore
  );
  const isProcoreObservationsConnected = isProjectIntegration(
    projectIntegrationsMap["procore.observations"]
  );
  const isProcoreRfisConnected = isProjectIntegration(
    projectIntegrationsMap["procore.rfis"]
  );

  return (
    isProcoreLegacyConnected &&
    isProcoreObservationsConnected &&
    isProcoreRfisConnected
  );
}
